import React, { useState } from 'react';
import loadable from '@loadable/component';
import { Route, Routes } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Loader } from '../../../common/components';

const GeneralSetting = loadable(
  () =>
    import('./GeneralSettingPage').then((module) => ({
      default: module.GeneralSetting
    })),
  {
    fallback: <Loader />
  }
);
const BiometricSetting = loadable(
  () =>
    import('./BiometricSetting/BiometricSettingPage').then((module) => ({
      default: module.BiometricSetting
    })),
  {
    fallback: <Loader />
  }
);
const OtherSetting = loadable(
  () =>
    import('./OtherSetting/OtherSettingPage.js').then((module) => ({
      default: module.OtherSettings
    })),
  {
    fallback: <Loader />
  }
);

import { SettingNavigation } from './Navigation/SettingNavigation';
import { useRouteAccessList } from '@hooks';

const SettingRoutes = ({ t, alert }) => {
  const [routeName, setRouteNames] = useState([]);
  // Route Access List
  useRouteAccessList((res) => {
    setRouteNames(res.data.route_name);
  });
  return (
    <Routes key={'routes'}>
      <Route path="/" element={<SettingNavigation t={t} routeName={routeName} alert={alert} />}>
        <Route
          key={'general_setting'}
          exact
          path="/general"
          element={<GeneralSetting t={t} routeName={routeName} alert={alert} />}
        />
        <Route
          key={'biometric_setting'}
          exact
          path="/biometric"
          element={<BiometricSetting t={t} routeName={routeName} alert={alert} />}
        />
        <Route
          key={'other_setting'}
          exact
          path="/other"
          element={<OtherSetting t={t} routeName={routeName} alert={alert} />}
        />
      </Route>
    </Routes>
  );
};
SettingRoutes.propTypes = {
  t: PropTypes.func
};
export default SettingRoutes;
